import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import {CommonMessages,ClientMessages} from 'src/app/shared/messages/messages.enum';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-agerange',
  templateUrl: './agerange.component.html',
  styleUrls: ['./agerange.component.css']
})
export class AgerangeComponent  extends BaseComponent  implements OnInit {

  public agerangeObj: any = [];
  cp = 1;
  ord = true;
  colname: "Age Range Name";
  text;
  checked = false;

  today: number = Date.now();
  constructor(private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService
  ) { 
    super();
  }
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getAgerange();
  }
  getAgerange() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getAgerange().subscribe(data => {
      self.agerangeObj = data; 
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  editAgerange(id) {
    this.router.navigate(['/corporate/newagerange'], { queryParams: { marid: id } });
  }
  deleteAgerange(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delAgerange(obj).subscribe(data => {
            if (data.status) {
              this.getAgerange();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateAgerangeStatus(event, id) {
    let value = event.source.checked;
    let obj = this.agerangeObj.find(element => {
      if (element.marid === id) {
        return true;
      }
    });
    obj = obj;
    obj.isactive = value;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', CommonMessages.activeInactiveConfirmation +" '"+ (value? "Active": "Inactive") +"'", 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          let agerangeObj = {
            
            isactive: obj.isactive,
            marid: id
          }
          this.master.updateAgerangeStatus(obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success(CommonMessages.statusUpdated);
            }
            this.ngxSpinnerService.hide();
          }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => {
        event.source.checked = !event.source.checked;
       // console.log(CommonMessages.dialogDismissMessage)
      });
  }
  clickEvent() { }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-theme-import.csv`, 'addingThemeBulk')
      .then(data => {
       // console.log(data);
        self.getAgerange();
      })
      .catch(err => {
        console.error(err);
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_age_range"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }
}


